// extracted by mini-css-extract-plugin
export var phone = "_3a-0";
export var phoneDragging = "_3a-1";